export const buildProfileUrl = (platform, handle) => {
    if (!handle) return null;
    if (handle.startsWith('http')) return handle;
    const cleaned = handle.replace(/^@/, '');
    if (platform === 'instagram') return `https://www.instagram.com/${cleaned}/`;
    if (platform === 'tiktok')    return `https://www.tiktok.com/@${cleaned}`;
    if (platform === 'youtube')   return `https://youtube.com/@${cleaned}`;
    if (platform === 'facebook')  return `https://facebook.com/${cleaned}`;
    if (platform === 'threads')   return `https://www.threads.com/@${cleaned}`;
    if (platform === 'x')         return `https://x.com/${cleaned}`;
    return null;
};
